import React from 'react';
import './Modal.css';
import { TriangleAlert, X } from 'lucide-react';
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';

const VisitProfileModal = ({
    isVisible,
    onClose,
    onConfirm,
    isLoading,
    title = 'Visit Profile',
    message = 'By changing visit profile, all the added events will be discarded, are you sure you want to continue?',
    cancelText = 'Cancel',
    confirmText = 'Yes',
    confirmColor = '#007B4E',
    showCancelIcon = false,
    containerWidth
}) => {
    return (
        isVisible && (
            <div className="modal-backdrop">
                <div className="modal-container visit-profile-modal" onClick={(e) => e.stopPropagation()} style={containerWidth ? { width: containerWidth } : {}}>
                    <div className='content-container'>
                        <div className='icon-container'>
                            <TriangleAlert className='visit-profile-warning-icon' />
                        </div>
                        <div className='text-container'>
                            <Heading6Semibold color='#1E293B' text={title} />
                            <BodyMediumRegular
                                color='#637381'
                                text={message}
                                textAlign='center'
                            />
                        </div>
                    </div>
                    <div className='button-contiainer'>
                        <button className='cancel-button'
                            onClick={onClose}
                        >
                            <div className='button-content'>
                                {showCancelIcon && <X className='icon cancel-cross-icon' size={16} strokeWidth={2} aria-hidden='true' />}
                                <BodyExtraSmallMedium color='#1E293B' text={cancelText} />
                            </div>
                        </button>
                        <button
                            className='primary-button-custom'
                            onClick={onConfirm}
                            disabled={isLoading}
                            style={{ backgroundColor: confirmColor }}
                        >
                            <BodyExtraSmallMedium color='#FFFFFF' text={confirmText} />
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default VisitProfileModal;